function escapeCell(value) {
    const str = value === null || value === undefined ? "" : String(value);
    if (str.includes(",") || str.includes('"') || str.includes("\n")) {
        return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
}

function formatDatetimeText(val) {
    if (!val) return "";
    try {
        const d = new Date(val.replace(" ", "T"));
        if (isNaN(d)) return val;
        return d.toLocaleString("en-US", {
            month: "short", day: "numeric",
            hour: "numeric", minute: "2-digit", hour12: true,
        });
    } catch {
        return val;
    }
}

// Mirror of the on-time badge logic in ChDrilldownDrawer so the exported CSV
// matches the on-screen classification exactly. onTimeBufferMins is the
// enterprise grace buffer (0 = default): deliveries up to that many minutes
// late still count as on-time.
function formatOntimeText(order, onTimeBufferMins = 0) {
    const promised = order.promisedDeliveryTime;
    const delivered = order.deliveryTime;
    if (promised && delivered) {
        // Truncate toward zero to match the backend's integer-minute lateness
        // ((to - from) / 60000 via integer division), so the badge/label always
        // agrees with the bucket the backend placed the order in.
        const diffMins = Math.trunc(
            (new Date(delivered.replace(" ", "T")) - new Date(promised.replace(" ", "T"))) / 60000
        );
        // diffMins > 0 => late, < 0 => early, 0 => exactly on time.
        if (diffMins < 0) return `${Math.abs(diffMins)} min early`;
        if (diffMins <= onTimeBufferMins) return "On-time";
        return `${diffMins} min late`;
    }
    // On-time is undefined without both a promise and a delivery time (matches
    // the backend, which leaves lateness NULL). Emit an empty cell — never
    // classify off deliveryDeltaMinutes, which is duration, not lateness.
    return "";
}

function formatCellForCsv(col, order, accountsMap, onTimeBufferMins) {
    const raw = order[col.key];
    switch (col.type) {
        case "orderlink":
            return raw ?? "";
        case "datetime":
            return formatDatetimeText(raw);
        case "badge":
            return raw ?? "";
        case "ontime":
            return formatOntimeText(order, onTimeBufferMins);
        case "waiting": {
            const mins = Number(raw);
            return isNaN(mins) ? "" : `${mins} min`;
        }
        case "company":
            return accountsMap?.[raw]?.companyName ?? raw ?? "";
        case "currency": {
            const val = Number(raw);
            return isNaN(val) ? "" : `$${val.toFixed(2)}`;
        }
        default:
            return raw ?? "";
    }
}

export function exportToCsv(columns, rows, filename, options = {}) {
    const { accountsMap, onTimeBufferMinutes = 0 } = options;

    const header = columns.map((col) => escapeCell(col.header)).join(",");
    const body = rows.map((order) =>
        columns.map((col) => escapeCell(formatCellForCsv(col, order, accountsMap, onTimeBufferMinutes))).join(",")
    );

    const csv = [header, ...body].join("\r\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
